<template>
  <span class="Color" :style="{width: width, height: width}">
    <span :style="{background: color && color.colors && color.colors[0] || '#fff'}" class="MainColor"></span>
    <span v-if="color && color.kind === 'duo'" :style="{'border-bottom-color': color && color.colors && color.colors[1] || '#fff', 'border-width': `0 0 ${width} ${width}`}" class="DuoColor"></span>
  </span>
</template>

<style type="text/css">
  .Color {
    display: block;
    position: relative;
  }
  .Color span {
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .Color .DuoColor {
    border-style: solid;
    border-color: transparent;
    height: 0;
    width: 0;
  }
</style>

<script>
export default {
  props: {
    color: Object,
    size: {type: String, default: 'normal'}
  },
  computed: {
    width() {
      switch (this.size) {
        case 'mini': return '20px';
        case 'small': return '24px';
        case 'normal': default: return '36px';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ColorBadge.vue